module.exports = __webpack_public_path__ + "static/media/hometown-3-main-shot.fa46281a.webp";